import moment from 'moment';
import auditStatusMap from '../config/app/audit-status';
import systemStatusMap from '../config/status/system';
import backendAppStatusMap from '../config/status/backend-app';
import backendServiceStatusMap from '../config/status/backend-service';
import backendServiceSubscriptionStatusMap
  from '../config/status/backend-service-subscription';
import userTypeRoleStatusMap from '../config/status/role';
import moduleAuditMap from '../config/status/module-audit';
import weixinAuditMap from '../config/status/weixin-audit';
import devtoolTaskMap from '../config/status/devtool-task';

export function formatTime (time, format = 'YYYY-MM-DD HH:mm') {
  let targetTime = time;
  if (+time === 0 || !time) {
    return '-';
  }
  if (+time < 10000000000) {
    // Unix时间戳
    targetTime = time * 1000;
  }
  return moment(targetTime).format(format);
}

export function auditStatusToStr (status) {
  return auditStatusMap[status] && auditStatusMap[status].auditLabel;
}

export function systemStatusToStr (status) {
  return systemStatusMap[status];
}

export function backendAppStatusToStr (status) {
  return backendAppStatusMap[status];
}

export function backendServiceStatusToStr (status) {
  return backendServiceStatusMap[status];
}

export function backendServiceSubscriptionStatusToStr (status) {
  return backendServiceSubscriptionStatusMap[status];
}

export function userTypeRoleStatusToStr (status) {
  return userTypeRoleStatusMap.userTypeRole[status];
}

export function userTypeStatusToStr (status) {
  return userTypeRoleStatusMap.userType[status];
}

export function roleTypeStatusToStr (status) {
  return userTypeRoleStatusMap.roleType[status];
}

export function roleNameStatusToStr (status) {
  return userTypeRoleStatusMap.roleName[status];
}

export function getModuleAuditTypeByStatus (status) {
  return moduleAuditMap[status] && moduleAuditMap[status].type;
}

export function getModuleAuditTextByStatus (status) {
  return moduleAuditMap[status] && moduleAuditMap[status].text;
}

export function getWeixinAuditTypeByStatus (status) {
  return weixinAuditMap[status] && weixinAuditMap[status].type;
}

export function getWeixinAuditTextByStatus (status) {
  return weixinAuditMap[status] && weixinAuditMap[status].text;
}

export function getDevtoolTaskTypeByStatus (status) {
  return devtoolTaskMap[status] && devtoolTaskMap[status].type;
}

export function getDevtoolTaskTextByStatus (status) {
  return devtoolTaskMap[status] && devtoolTaskMap[status].text;
}

export function formatOrgName (name) {
  if (name.length > 15) {
    name = name.substr(0, 15) + '...';
  }
  return name;
}
